import React from 'react';

import type {
	StripeCardCvcElementChangeEvent,
	StripeCardExpiryElementChangeEvent,
	StripeCardNumberElementChangeEvent,
} from '@stripe/stripe-js';

import { useI18n } from '@change-corgi/core/react/i18n';

import type { StripeValidationErrors } from 'src/app/shared/utils/payments';

import { StyleWrapper } from '../../components/StyleWrapper';

import { CardCvcElementWrapper } from './StripeElementWrappers/CardCvcElementWrapper';
import { CardExpiryElementWrapper } from './StripeElementWrappers/CardExpiryElementWrapper';
import { CardNumberElementWrapper } from './StripeElementWrappers/CardNumberElementWrapper';

type Props = {
	validationErrors?: StripeValidationErrors;
	onChange?: (
		e: StripeCardNumberElementChangeEvent | StripeCardExpiryElementChangeEvent | StripeCardCvcElementChangeEvent,
	) => void;
	onCardNumberFieldFocus: () => void;
	onCardExpiryFieldFocus: () => void;
	onCardCVCFieldFocus: () => void;
};

export const StripeCreditCardElements: React.FC<Props> = ({
	validationErrors,
	onChange,
	onCardNumberFieldFocus,
	onCardExpiryFieldFocus,
	onCardCVCFieldFocus,
}) => {
	const { translate } = useI18n();

	return (
		<>
			<div className="relative mb-2" data-qa="credit-card-number">
				<div className="absolute top-0 right-0">
					<img
						alt={translate('corgi.payments.stripe_elements.card_image_alt_text')}
						src="https://assets.change.org/app-assets/victory_fund/credit-card-icons-2.png"
						height="20px"
						width="163px"
					/>
				</div>
				<StyleWrapper
					label={translate('fe.components.credit_card.cc_number')}
					errorMessage={validationErrors?.card_number ? translate(validationErrors.card_number) : undefined}
					onFocus={onCardNumberFieldFocus}
				>
					<CardNumberElementWrapper onChange={onChange} />
				</StyleWrapper>
			</div>

			<div className="flex w-full">
				<div className="mr-2 flex-1" data-qa="credit-card-expiry">
					<StyleWrapper
						label={translate('corgi.payments.stripe_elements.expiration')}
						errorMessage={validationErrors?.card_expiration ? translate(validationErrors.card_expiration) : undefined}
						onFocus={onCardExpiryFieldFocus}
					>
						<CardExpiryElementWrapper onChange={onChange} />
					</StyleWrapper>
				</div>
				<div className="flex-1" data-qa="credit-card-cvc">
					<StyleWrapper
						label={translate('corgi.payments.stripe_elements.cvc')}
						errorMessage={validationErrors?.card_cvc ? translate(validationErrors.card_cvc) : undefined}
						onFocus={onCardCVCFieldFocus}
					>
						<CardCvcElementWrapper onChange={onChange} />
					</StyleWrapper>
				</div>
			</div>
		</>
	);
};
